<template>
  <div class="profile-container">
    <CardIeaAppMain colorCard="transparent" title="" class="premium-wrapper">
      <v-col cols="12" class="pa-0">
        
        <!-- Hero Header -->
        <div class="hero-header glass-panel mb-4 py-3 px-6 mx-4 mt-4">
          <div class="d-flex align-center justify-space-between w-100 flex-wrap">
            <div class="d-flex align-center mb-2 mb-md-0">
              <v-btn icon dark color="primary" class="mr-4 glass-btn" @click="$router.go(-1)">
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
              <div>
                <h1 class="text-h5 font-weight-bold primary-text mb-0">{{ title }}</h1>
                <p class="text-caption grey--text text--darken-1 mb-0">Visualiza y edita la información del usuario</p>
              </div>
            </div>
            <v-icon size="48" color="primary" class="opacity-30 d-none d-sm-block">mdi-card-account-details-outline</v-icon>
          </div>
        </div>

        <v-col cols="12" v-if="active == 0">
          <v-alert prominent type="info" class="mx-4 rounded-xl glass-card">
            Servicio temporalmente inactivo
          </v-alert>
        </v-col>
        <div v-else class="px-0">
          <div v-if="userProfile" class="premium-profile-layout pb-8">
            <!-- 1. Full-width Hero Cover -->
            <div class="profile-hero-wrapper">
              <v-img
                class="profile-hero-cover"
                :height="$vuetify.breakpoint.name == 'xs' ? 200 : 320"
                :src="userProfile.cover_photo ? userProfile.cover_photo : 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'"
                style="background: linear-gradient(135deg, #095da1 0%, #8fc6dc 50%, #a7ba38 100%);"
              >
                <div class="hero-gradient"></div>
                <v-btn
                  class="mx-4 mt-4 float-right glass-btn"
                  dark
                  small
                  color="rgba(0,0,0,0.5)"
                  @click="uploadPhotoCover()"
                  v-if="editProfile"
                  title="Cambiar imagen de portada"
                >
                  <v-icon dark small>mdi-camera</v-icon> Portada
                </v-btn>
              </v-img>
            </div>

            <!-- 2. Two-Column Layout -->
            <v-row 
              class="profile-content-row px-4 mx-auto" 
              style="max-width: 1400px; position: relative; z-index: 2;"
              :style="{ 'margin-top': $vuetify.breakpoint.smAndDown ? '-60px' : '-100px' }"
            >
              
              <!-- LEFT COLUMN: Profile Info Card -->
              <v-col cols="12" md="4" lg="3">
                <v-card class="glass-card rounded-xl profile-sticky-card pa-6 text-center" elevation="10">
                  
                  <!-- Avatar -->
                  <div class="avatar-container mb-4 mx-auto" style="position: relative;" :style="{ 'margin-top': $vuetify.breakpoint.smAndDown ? '-40px' : '-60px' }">
                    <v-hover v-slot="{ hover }">
                      <v-avatar
                        class="profile-avatar-premium shadow-xl mx-auto"
                        :size="$vuetify.breakpoint.smAndDown ? 120 : 160"
                        style="border: 6px solid rgba(255,255,255,0.8); background: linear-gradient(135deg, #095da1, #8fc6dc);"
                      >
                        <!-- Initial text behind the image -->
                        <div style="position: absolute; width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; z-index: 0;">
                            <span class="white--text text-h2 font-weight-bold" v-if="userProfile.empleado == null">
                                {{ userProfile.Nombres ? userProfile.Nombres.charAt(0).toUpperCase() : '' }}
                            </span>
                            <span class="white--text text-h2 font-weight-bold" v-else>
                                {{ userProfile.empleado.nombres ? userProfile.empleado.nombres.charAt(0).toUpperCase() : '' }}
                            </span>
                        </div>

                        <!-- The Image -->
                        <v-img :src="userProfile.imagen" v-if="userProfile.imagen && userProfile.imagen !== 'null'" @click="openImageProfile()" style="cursor: pointer; position: relative; z-index: 1; width: 100%; height: 100%;"></v-img>
                        <v-img :src="userProfile.empleado.imagen" v-else-if="userProfile.empleado && userProfile.empleado.imagen && userProfile.empleado.imagen !== 'null'" @click="openImageProfile()" style="cursor: pointer; position: relative; z-index: 1; width: 100%; height: 100%;"></v-img>

                        <template v-if="hover && editProfile">
                           <div class="avatar-overlay d-flex align-center justify-center" @click="uploadPhotoProfile()" style="background: rgba(0,0,0,0.5); cursor: pointer; position: absolute; z-index: 2; top: 0; left: 0; right: 0; bottom: 0;">
                              <v-icon color="white" size="32">mdi-camera</v-icon>
                           </div>
                        </template>
                      </v-avatar>
                    </v-hover>
                  </div>

                  <!-- Name and Stars -->
                  <h2 class="text-h5 font-weight-bold primary-text mb-1" v-if="userProfile.empleado == null">
                    {{ userProfile.Nombres }} {{ userProfile.Apellidos }}
                  </h2>
                  <h2 class="text-h5 font-weight-bold primary-text mb-1" v-else>
                    {{ userProfile.empleado.nombres }} {{ userProfile.empleado.apellidos }}
                  </h2>
                  
                  <div class="mb-4">
                    <v-rating :value="userProfile.puntaje" color="amber" dense half-increments readonly size="18"></v-rating>
                  </div>

                  <!-- Action Buttons -->
                  <div class="d-flex flex-column gap-2 mb-6">
                    <template v-if="user.IDStB !== userProfile.IDStB">
                      <v-btn rounded class="custom-btn-shadow font-weight-bold text-none" color="primary" v-if="!isFollower()" @click="follow()">
                        <v-icon left>mdi-account-plus</v-icon> Seguir
                      </v-btn>
                      <v-btn rounded outlined class="font-weight-bold text-none" color="secondary" v-else @click="unfollow()">
                        <v-icon left>mdi-account-minus</v-icon> Dejar de seguir
                      </v-btn>
                    </template>
                    <template v-else>
                      <v-btn rounded outlined color="info" class="font-weight-bold text-none" @click="editProfile = true; content = userProfile.descripcion; estadoCivil = userProfile.estadoCivil;" v-if="!editProfile">
                        <v-icon left>mdi-pencil</v-icon> Editar Perfil
                      </v-btn>
                      <v-btn rounded class="custom-btn-shadow font-weight-bold text-none" color="success" @click="updateProfile()" v-else>
                        <v-icon left>mdi-content-save</v-icon> Guardar
                      </v-btn>
                    </template>
                  </div>

                  <v-divider class="opacity-30 mb-4"></v-divider>

                  <!-- Stats Grid -->
                  <v-row class="profile-stats-grid mb-4">
                    <v-col cols="6" class="text-center cursor-pointer hover-stat" @click="showFollowers = true" style="cursor: pointer;">
                      <div class="text-h5 font-weight-bold primary-text">{{ userProfile.followers.length }}</div>
                      <div class="text-caption grey--text text--darken-1 text-uppercase tracking-wide font-weight-bold">Seguidores</div>
                    </v-col>
                    <v-col cols="6" class="text-center cursor-pointer hover-stat" @click="showFollowings = true" style="cursor: pointer;">
                      <div class="text-h5 font-weight-bold primary-text">{{ userProfile.followings.length }}</div>
                      <div class="text-caption grey--text text--darken-1 text-uppercase tracking-wide font-weight-bold">Siguiendo</div>
                    </v-col>
                  </v-row>

                  <v-divider class="opacity-30 mb-4"></v-divider>

                  <!-- About / Personal Info -->
                  <div class="text-left">
                    <h3 class="text-subtitle-1 font-weight-bold mb-3 primary-text">Sobre mí</h3>
                    
                    <div class="d-flex align-center mb-2" v-if="userProfile.settings && userProfile.settings.showNacimiento">
                      <v-icon small color="grey darken-1" class="mr-3">mdi-cake</v-icon>
                      <span class="text-body-2 grey--text text--darken-3 font-weight-medium">
                        {{ userProfile.empleado == null ? userProfile.Nacimiento : userProfile.empleado.fecha_nacimiento }}
                      </span>
                    </div>

                    <div class="d-flex align-center mb-4" v-if="userProfile.estadoCivil || editProfile || (userProfile.settings && userProfile.settings.showEstadoCivil)">
                      <v-icon small color="grey darken-1" class="mr-3">mdi-heart-outline</v-icon>
                      <div v-if="editProfile" style="width: 100%;">
                        <v-select :items="estadosCiviles" label="Estado civil" v-model="estadoCivil" dense hide-details class="mt-0 pt-0"></v-select>
                      </div>
                      <span v-else class="text-body-2 grey--text text--darken-3 font-weight-medium">
                        {{ userProfile.estadoCivil }}
                      </span>
                    </div>

                    <div v-if="editProfile">
                      <v-textarea outlined v-model="content" name="input-7-4" label="Tu biografía..." rows="3" dense class="rounded-lg bg-white"></v-textarea>
                    </div>
                    <div v-else>
                      <p v-if="userProfile.empleado == null && userProfile.settings && userProfile.settings.showDescription && userProfile.descripcion && userProfile.descripcion != 'null'" class="text-body-2 grey--text text--darken-2 line-height-relaxed mb-0">
                        {{ userProfile.descripcion }}
                      </p>
                      <p v-if="userProfile.empleado != null && userProfile.settings && userProfile.settings.showDescription && userProfile.empleado.descripcion && userProfile.empleado.descripcion != 'null'" class="text-body-2 grey--text text--darken-2 line-height-relaxed mb-0">
                        {{ userProfile.empleado.descripcion }}
                      </p>
                    </div>
                  </div>

                </v-card>
              </v-col>

              <!-- RIGHT COLUMN: Masonry Feed -->
              <v-col cols="12" md="8" lg="9">
                <v-alert prominent type="info" class="rounded-xl glass-card mx-2 mt-2" v-if="publications.length == 0 && waiting == false">
                  <div class="d-flex align-center">
                    <v-icon large color="info" class="mr-4">mdi-post-outline</v-icon>
                    <div>
                      <h3 class="text-h6 font-weight-bold mb-1">Aún no hay publicaciones</h3>
                      <p class="mb-0">{{ userProfile.Nombres }} no ha publicado nada todavía.</p>
                    </div>
                  </div>
                </v-alert>
                
                <div v-else class="feed-wrapper mt-2">
                  <v-container class="pa-0">
                <masonry
                  :gutter="{ default: '30px', 700: '15px' }"
                  :cols="{ default: 2, 1000: 2, 700: 1, 500: 1 }"
                >
                  <v-card
                    v-for="item in publicationsFiltered"
                    :key="item.id"
                    class="mb-4 glass-card rounded-xl hover-card border-light"
                    elevation="0"
                  >
                    <div v-if="item.create_by_client == true">
                      <v-list-item two-line>
                        <v-list-item-avatar
                          size="48"
                          color="primary lighten-4"
                          class="mr-4 shadow-sm"
                          style="cursor: pointer; border: 2px solid white;"
                        >
                          <v-img :src="item.cliente.empleado.imagen" v-if="item.cliente.empleado.imagen"></v-img>
                          <v-icon v-else color="primary">mdi-account</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title class="text-subtitle-1 font-weight-bold primary-text">
                            {{ item.cliente.empleado.nombres }}
                            {{ item.cliente.empleado.apellidos }}
                          </v-list-item-title>
                          <v-list-item-subtitle>
                            <v-rating
                              :value="item.cliente.puntaje"
                              color="amber"
                              dense
                              half-increments
                              readonly
                              size="14"
                            ></v-rating>
                          </v-list-item-subtitle>
                          <v-list-item-subtitle
                            ><small
                              >Hace {{ gettime(item.updated_at) }}</small
                            ></v-list-item-subtitle
                          >
                        </v-list-item-content>
                      </v-list-item>
                    </div>

                    <div v-else>
                      <v-list-item v-if="item.alumno != null" two-line>
                        <v-list-item-avatar
                          size="48"
                          color="primary lighten-4"
                          class="mr-4 shadow-sm"
                          style="cursor: pointer; border: 2px solid white;"
                          title="Ver perfil"
                          @click="openProfile(item.alumno.IDStB, 'alumno')"
                        >
                          <v-img :src="item.alumno.imagen" v-if="item.alumno.imagen"></v-img>
                          <v-icon v-else color="primary">mdi-account</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title class="text-subtitle-1 font-weight-bold primary-text">
                            {{ item.alumno.Nombres }}
                            {{ item.alumno.Apellidos }}
                          </v-list-item-title>
                          <v-list-item-subtitle>
                            <v-rating
                              :value="item.alumno.puntaje"
                              color="amber"
                              dense
                              half-increments
                              readonly
                              size="14"
                            ></v-rating>
                          </v-list-item-subtitle>
                          <v-list-item-subtitle
                            ><small
                              >Hace {{ gettime(item.updated_at) }}</small
                            ></v-list-item-subtitle
                          >
                        </v-list-item-content>
                      </v-list-item>

                      <v-list-item v-else two-line>
                        <v-list-item-avatar
                          size="48"
                          color="primary lighten-4"
                          class="mr-4 shadow-sm"
                          style="cursor: pointer; border: 2px solid white;"
                          title="Ver perfil"
                          @click="openProfile(item.profesor.IDStB, 'profesor')"
                        >
                          <v-img :src="item.profesor.empleado.imagen" v-if="item.profesor.empleado.imagen"></v-img>
                          <v-icon v-else color="primary">mdi-account</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title class="text-subtitle-1 font-weight-bold primary-text">
                            {{ item.profesor.empleado.nombres }}
                            {{ item.profesor.empleado.apellidos }}
                          </v-list-item-title>
                          <v-list-item-subtitle>
                            <v-rating
                              :value="item.profesor.puntaje"
                              color="amber"
                              dense
                              half-increments
                              readonly
                              size="14"
                            ></v-rating>
                          </v-list-item-subtitle>
                          <v-list-item-subtitle
                            ><small
                              >Hace {{ gettime(item.updated_at) }}</small
                            ></v-list-item-subtitle
                          >
                        </v-list-item-content>
                      </v-list-item>
                    </div>

                    <v-carousel
                      hide-delimiters
                      :show-arrows="
                        item.images.length >= 2 ||
                        (item.images.length == 1 && item.video)
                          ? true
                          : false
                      "
                      v-if="item.images.length >= 2 || item.video"
                      height="300"
                    >
                      <v-carousel-item
                        v-for="(image, j) in item.images.filter((d) => {
                          return d.active == 1;
                        })"
                        :key="j"
                        :src="image.image"
                        @click="openPublication(item)"
                      ></v-carousel-item>
                      <v-carousel-item v-if="item.video">
                        <iframe
                          v-if="item.video"
                          width="100%"
                          height="300"
                          :src="item.video"
                          frameborder="0"
                          allow="autoplay; encrypted-media"
                          allowfullscreen
                          class="mt-10"
                        ></iframe>
                      </v-carousel-item>
                    </v-carousel>
                    <v-img
                      @click="openPublication(item)"
                      v-if="item.images.length == 1"
                      :src="item.images[0].image"
                    ></v-img>
                    <v-card-text
                      style="color: #424242"
                      v-html="item.contentHtml.substring(0, 150)"
                    >
                    </v-card-text>
                    <v-card-text style="color: #424242" class="mt-0 pt-0 pb-0">
                      <small
                        @click="openPublication(item)"
                        style="text-decoration: underline;cursor: pointer;"
                        >Ver publicación</small
                      >
                    </v-card-text>
                    <v-card-actions style="padding-left: 20px;">
                      <v-avatar
                        size="30"
                        :color="getColor()"
                        v-for="(like, i) in item.likes.slice(0, 5)"
                        :key="i"
                        style="margin-left: -15px;cursor: pointer;"
                        @click="openProfile(like.alumno.IDStB, 'alumno')"
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-img
                              v-bind="attrs"
                              v-on="on"
                              :src="like.alumno.imagen"
                              v-if="like.alumno.imagen"
                            ></v-img>
                            <v-icon v-bind="attrs" v-on="on" v-else
                              >mdi-account</v-icon
                            >
                          </template>
                          <span
                            >{{ like.alumno.Nombres }}
                            {{ like.alumno.Apellidos }}</span
                          >
                        </v-tooltip>
                      </v-avatar>

                      <v-avatar
                        size="30"
                        :color="getColor()"
                        v-for="(like, i) in item.likes_profesor.slice(0, 5)"
                        :key="i + 'profesor'"
                        style="margin-left: -15px;cursor: pointer;"
                        @click="openProfile(like.profesor.IDStB, 'profesor')"
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-img
                              v-bind="attrs"
                              v-on="on"
                              :src="like.profesor.empleado.imagen"
                              v-if="like.profesor.empleado.imagen"
                            ></v-img>
                            <v-icon v-bind="attrs" v-on="on" v-else
                              >mdi-account</v-icon
                            >
                          </template>
                          <span
                            >{{ like.profesor.empleado.nombres }}
                            {{ like.profesor.empleado.apellidos }}</span
                          >
                        </v-tooltip>
                      </v-avatar>
                      <v-spacer></v-spacer>
                      <v-btn
                        icon
                        @click="addLike(item)"
                        v-if="
                          item.likes.filter((d) => {
                            return (
                              d.alumno.IDStB == user.IDStB &&
                              d.type_user == user.tipoUsuario
                            );
                          }).length == 0 &&
                            item.likes_profesor.filter((d) => {
                              return (
                                d.profesor.IDStB == user.IDStB &&
                                d.type_user == user.tipoUsuario
                              );
                            }).length == 0
                        "
                      >
                        <v-icon color="red">mdi-heart-outline</v-icon
                        ><small>{{
                          item.likes.length + item.likes_profesor.length
                        }}</small>
                      </v-btn>
                      <v-btn icon v-else @click="removeLike(item)">
                        <v-icon color="red">mdi-heart</v-icon
                        ><small>{{
                          item.likes.length + item.likes_profesor.length
                        }}</small>
                      </v-btn>
                      <v-btn icon class="ml-5" @click="openPublication(item)">
                        <v-icon>mdi-comment-outline</v-icon
                        ><small>{{
                          item.comments.length + item.comments_profesor.length
                        }}</small>
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </masonry>
                  </v-container>
                  <p
                    class="m-10 p-5 preview d-flex align-center justify-center pa-4 mx-auto grey--text"
                    v-if="current_page == last_page"
                  >
                    No hay más publicaciones para mostrar
                  </p>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-col>

      <ModalCustom
        :show="show"
        @update="onUpdateShow"
        :content="contentAlert"
        :type="typeAlert"
      />
      <ModalCustom
        :show="showImageProfile"
        @update="onUpdateShowImageProfile"
        :image="userProfile.imagen"
        :type="typeAlert"
        :title="userProfile.Nombres + ' ' + userProfile.Apellidos"
        :maxWidth="500"
        v-if="userProfile"
      />
      <Publication
        :showDialog="showPublication"
        @updatepublication="onUpdateShowPublication"
        :publication="publicationSelected"
      />

      <template>
        <v-dialog v-model="showFollowers" max-width="500" scrollable>
          <v-card v-if="userProfile">
            <v-card-title class="text-h6 justify-center">
              {{ userProfile.Nombres }} es seguido por
              {{ userProfile.followers.length }} personas
              <v-spacer></v-spacer>
              <v-btn icon dark @click="showFollowers = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text style="height: 300px;">
              <v-list-item
                v-for="(follower, index) in userProfile.followers"
                :key="index"
                style="cursor: pointer;"
              >
                <div
                  v-if="follower.follower != null"
                  @click="openProfile(follower.follower_id, 'alumno')"
                >
                  <v-list-item-avatar class="mr-2">
                    <v-img
                      :src="follower.follower.imagen"
                      v-if="follower.follower.imagen"
                    ></v-img>
                    <v-icon color="#a7ba38" v-else>mdi-account</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title
                      >{{ follower.follower.Nombres }}
                      {{ follower.follower.Apellidos }}</v-list-item-title
                    >
                  </v-list-item-content>
                </div>

                <div
                  v-else
                  @click="openProfile(follower.follower_id, 'profesor')"
                >
                  <v-list-item-avatar class="mr-2">
                    <v-img
                      :src="follower.follower_profesor.empleado.imagen"
                      v-if="follower.follower_profesor.empleado.imagen"
                    ></v-img>
                    <v-icon color="#a7ba38" v-else>mdi-account</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title
                      >{{ follower.follower_profesor.empleado.nombres }}
                      {{
                        follower.follower_profesor.empleado.apellidos
                      }}</v-list-item-title
                    >
                  </v-list-item-content>
                </div>
              </v-list-item>
            </v-card-text>

            <v-card-text>
              <div class="box-container  justify-center">
                <span class="box" style="background-color: #085da1"> </span>
                <span class="box" style="background-color: #a7ba38"> </span>
                <span class="box" style="background-color: #e79024"> </span>
                <span class="box" style="background-color: #db1d4a"> </span>
                <span class="box" style="background-color: #8fc6dc"> </span>
              </div>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="justify-space-around">
              <v-btn
                color="primary darken-1"
                text
                @click="showFollowers = false"
                small
              >
                Cerrar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>

      <template>
        <v-dialog v-model="showFollowings" max-width="500" scrollable>
          <v-card v-if="userProfile">
            <v-card-title class="text-h6 justify-center">
              {{ userProfile.Nombres }} esta siguiendo a
              {{ userProfile.followings.length }} personas
              <v-spacer></v-spacer>
              <v-btn icon dark @click="showFollowings = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text style="height: 300px;">
              <v-list-item
                v-for="(following, index) in userProfile.followings"
                :key="index"
                style="cursor: pointer;"
              >
                <div
                  v-if="following.following != null"
                  @click="openProfile(following.following_id, 'alumno')"
                >
                  <v-list-item-avatar class="mr-2">
                    <v-img
                      :src="following.following.imagen"
                      v-if="following.following.imagen"
                    ></v-img>
                    <v-icon color="#a7ba38" v-else>mdi-account</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title
                      >{{ following.following.Nombres }}
                      {{ following.following.Apellidos }}</v-list-item-title
                    >
                  </v-list-item-content>
                </div>

                <div
                  v-else
                  @click="openProfile(following.following_id, 'profesor')"
                >
                  <v-list-item-avatar class="mr-2">
                    <v-img
                      :src="following.following_profesor.empleado.imagen"
                      v-if="following.following_profesor.empleado.imagen"
                    ></v-img>
                    <v-icon color="#a7ba38" v-else>mdi-account</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title
                      >{{ following.following_profesor.empleado.nombres }}
                      {{
                        following.following_profesor.empleado.apellidos
                      }}</v-list-item-title
                    >
                  </v-list-item-content>
                </div>
              </v-list-item>
            </v-card-text>

            <v-card-text>
              <div class="box-container  justify-center">
                <span class="box" style="background-color: #085da1"> </span>
                <span class="box" style="background-color: #a7ba38"> </span>
                <span class="box" style="background-color: #e79024"> </span>
                <span class="box" style="background-color: #db1d4a"> </span>
                <span class="box" style="background-color: #8fc6dc"> </span>
              </div>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="justify-space-around">
              <v-btn
                color="primary darken-1"
                text
                @click="showFollowings = false"
                small
              >
                Cerrar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <input
          id="file-upload"
          type="file"
          @change="onFileChangeProfile"
          ref="fileInputProfile"
          style="visibility: hidden;"
        />
        <input
          id="file-upload"
          type="file"
          @change="onFileChangeCover"
          ref="fileInputCover"
          style="visibility: hidden;"
        />
      </template>
      <!-- </v-row> -->
    </CardIeaAppMain>
  </div>
</template>

<script>
// import CardIeaApp from "../../components/CardIeaApp";
import CardIeaAppMain from "../../components/CardIeaAppMain";
import ModalCustom from "../../components/ModalCustom";
import Publication from "../../components/Publication";
import moment from "moment";
moment.locale("es");
export default {
  name: "Profile",
  components: {
    // CardIeaApp,
    CardIeaAppMain,
    ModalCustom,
    Publication,
  },

  data: () => ({
    title: "Perfil",
    content: "",
    Nacimiento: "",
    estadoCivil: "",
    estadosCiviles: ["Soltero", "Casado", "Viudo", "En algo"],
    selection: 1,
    show: false,
    contentAlert: "",
    typeAlert: "modal-info",
    showPublication: false,
    publications: [],
    imageSelected: "",
    publicationSelected: null,
    // loading:false,
    url: null,
    files: [],
    limit: 10,
    video: null,
    current_page: 0,
    last_page: 1,
    action: "add",
    publication: null,
    current_index: null,
    images_deleted: [],
    active: 1,
    userProfile: null,
    showFollowers: false,
    showFollowings: false,
    followers: [],
    followings: [],
    editProfile: false,
    filePhoto: null,
    filePhotoCover: null,
    showImageProfile: false,
    tipo_usuario: null,
    waiting: true,
  }),
  mounted() {
    this.current_page = 0;
    this.verifierStatus();
    let id = this.$route.params.id;
    let tipo_usuario = this.$route.params.tipo_usuario;
    this.tipo_usuario = tipo_usuario;
    if (id) {
      this.getProfile(id, tipo_usuario);
    } else {
      console.log(this.user);
      this.getProfile(this.user.IDStB, this.user.tipoUsuario);
    }
    window.addEventListener("scroll", this.onScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    publicationsFiltered() {
      const result = [];
      for (const p of this.publications) {
        p.contentHtml = p.content;
        if (p.taggeds && p.taggeds.length > 0) {
          p.taggeds.forEach((val) => {
            console.log(val);
            let t = new Date().getTime();
            p.contentHtml = p.content.replace(
              val.shortName,
              '<a class="tagged" href="profile/' +
                val.IDStB +
                "/" +
                val.tipoUsuario +
                "?t=" +
                t +
                '">' +
                val.shortName +
                "</a>"
            );
          });
        }
        result.push(p);
      }
      console.log(result);
      return result;
    },
  },
  methods: {
    async verifierStatus() {
      this.$API
        .get({
          url: "publications-service-status",
        })
        .then((res) => {
          this.active = res;
        });
    },
    async getAlumnoLogged() {
      this.$API
        .get({
          url: "alumno/getAlumno",
        })
        .then((res) => {
          console.log(res);
          this.followers = res.followers;
          this.followings = res.followings;
        });
    },
    gettime(date_publish) {
      let current_date = moment();
      let published_date = moment(date_publish);
      return moment.duration(current_date - published_date).humanize();
    },
    async getProfile(id, tipo_usuario) {
      // this.loading = true;
      this.$API
        .get({
          url: "profile/" + id + "/" + tipo_usuario,
        })
        .then((res) => {
          console.log(res);
          this.userProfile = res;
          // this.loading = false;
          this.getPublications(true);
        });
    },

    async getPublications(reload = false) {
      let idCurrentUser = this.user.IDStB;
      if (
        this.userProfile &&
        this.current_page !== this.last_page &&
        this.current_page < this.last_page
      ) {
        // this.loading = true;
        this.$API
          .get({
            url:
              "publications-by-user?alumno_id=" +
              this.userProfile.IDStB +
              "&page=" +
              this.current_page +
              "&current_user_id=" +
              idCurrentUser, // Añadir idCurrentUser como parámetro
          })
          .then((res) => {
            console.log(res);
            if (reload) {
              this.publications = res.data;
              this.waiting = false;
            } else {
              this.publications.push(...res.data);
              this.waiting = false;
            }
            this.last_page = res.last_page;
            this.current_page++;
            // this.loading = false;
          });
      }
    },

    async getPublication(id) {
      this.$API
        .get({
          url: "publications/" + id,
        })
        .then((res) => {
          this.openPublication(res);
        });
    },
    async test() {
      this.$API
        .get({
          url: "notifications?type=message",
        })
        .then((res) => {
          console.log(res);
        });
    },
    async follow() {
      await this.$API
        .post({
          url: "follow/" + this.userProfile.IDStB,
          data: {},
        })
        .then((res) => {
          this.userProfile.followers.push(res);
        });
    },
    async unfollow() {
      await this.$API
        .post({
          url: "unfollow/" + this.userProfile.IDStB,
          data: {},
        })
        .then((res) => {
          let t = this.userProfile.followers.findIndex((d) => {
            return d.follower_id == this.user.IDStB;
          });
          if (t !== -1) {
            this.userProfile.followers.splice(t, 1);
          }
          console.log(res);
        });
    },
    async uploadVideoEvent() {
      this.$refs.fileInputVideo.click();
    },
    openPublication(item) {
      this.showPublication = true;
      this.publicationSelected = item;
    },
    onUpdateShow(newData) {
      this.show = newData;
    },
    onUpdateShowPublication(newData) {
      this.showPublication = newData;
    },
    onUpdateShowImageProfile(newData) {
      this.showImageProfile = newData;
    },
    async addLike(item) {
      console.log("data del alumno o del usuario:", item);
      await this.$API
        .post({
          url: "publications-like",
          data: {
            publication_id: item.id,
          },
        })
        .then((res) => {
          if (res.alumno != null) {
            item.likes.push(res);
          } else {
            item.likes_profesor.push(res);
          }
        });
    },
    async updateProfile() {
      var formData = new FormData();
      formData.append("descripcion", this.content);
      formData.append("estadoCivil", this.estadoCivil);
      if (this.filePhoto) {
        formData.append("imagen", this.filePhoto);
      }
      if (this.filePhotoCover) {
        formData.append("cover_photo", this.filePhotoCover);
      }
      await this.$API
        .post({
          url: "profile",
          data: formData,
        })
        .then((res) => {
          if (res.empleado == null) {
            this.editProfile = false;
            this.userProfile.descripcion = res.descripcion;
            this.userProfile.estadoCivil = res.estadoCivil;
            this.userProfile.imagen = res.imagen;
          } else {
            this.editProfile = false;
            this.userProfile.empleado.descripcion = res.empleado.descripcion;
            //this.userProfile.estadoCivil = res.estadoCivil;
            this.userProfile.empleado.imagen = res.empleado.imagen;
          }
        });
    },
    async removeLike(item) {
      await this.$API
        .delete({
          url: "publications-like-bypost/" + item.id,
        })
        .then((res) => {
          if (res) {
            item.likes = item.likes.filter((d) => {
              return d.alumno.IDStB != this.user.IDStB;
            });
            item.likes_profesor = item.likes_profesor.filter((d) => {
              return d.profesor.IDStB != this.user.IDStB;
            });
          }
        });
    },
    deleteFileThumnail(index, id) {
      this.files.splice(index, 1);
      if (id) {
        this.images_deleted.push(id);
        console.log(this.images_deleted);
      }
    },
    onScroll() {
      if (
        document.body.scrollHeight - window.innerHeight - window.top.scrollY ===
        0
      ) {
        this.getPublications();
      }
    },
    openProfile(id, tipo_usuario) {
      console.log(id, tipo_usuario);
      this.$router.push({
        name: "Profile",
        params: {
          id: id,
          tipo_usuario: tipo_usuario,
        },
        query: {
          t: new Date().getTime(),
        },
      });
    },
    isFollower() {
      let t = this.userProfile.followers.filter((d) => {
        return d.follower_id == this.user.IDStB;
      });
      console.log(t);
      return t.length > 0;
    },
    async uploadPhotoProfile() {
      this.$refs.fileInputProfile.click();
    },
    onFileChangeProfile(e) {
      let i = e.target.files[0];
      if (i.type.match("image.*")) {
        this.filePhoto = i;
        this.userProfile.imagen = URL.createObjectURL(i);
      } else {
        this.typeAlert = "info";
        this.contentAlert = "Agrega un formato válido de fotografia";
        this.show = true;
      }
    },
    async uploadPhotoCover() {
      this.$refs.fileInputCover.click();
    },
    onFileChangeCover(e) {
      let i = e.target.files[0];
      if (i.type.match("image.*")) {
        this.filePhotoCover = i;
        this.userProfile.cover_photo = URL.createObjectURL(i);
      } else {
        this.typeAlert = "info";
        this.contentAlert = "Agrega un formato válido de fotografia";
        this.show = true;
      }
    },
    openImageProfile() {
      this.showImageProfile = true;
    },
    getColor() {
      let colors = ["#a7ba38", "#095da1", "#e79029", "#dd404a", "#8fc6dc"];
      let min = 0;
      var max = colors.length;
      var random = Math.floor(Math.random() * (max - min)) + min;
      return colors[random];
    },
  },
};
</script>
<style>
/* Glassmorphism Classes (Premium UI) */
.profile-container { background: transparent !important; min-height: calc(100vh - 120px); }
.glass-panel { background: rgba(255, 255, 255, 0.7) !important; backdrop-filter: blur(16px) !important; border: 1px solid rgba(255, 255, 255, 0.5) !important; box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.05) !important; border-radius: 20px; padding: 24px; }
.glass-card { background: rgba(255, 255, 255, 0.85) !important; backdrop-filter: blur(16px) !important; border: 1px solid rgba(255, 255, 255, 0.4) !important; }
.glass-btn { background: rgba(25, 118, 210, 0.1) !important; backdrop-filter: blur(4px) !important; box-shadow: none !important; transition: all 0.3s ease; }
.glass-btn:hover { background: rgba(25, 118, 210, 0.2) !important; transform: translateY(-2px); }
.border-light { border: 1px solid rgba(0, 0, 0, 0.05) !important; }
.hover-card { transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1); }
.hover-card:hover { transform: translateY(-2px); box-shadow: 0 12px 24px -8px rgba(0, 0, 0, 0.12) !important; }
.shadow-lg { box-shadow: 0 10px 25px rgba(0,0,0,0.2) !important; }
.shadow-sm { box-shadow: 0 2px 8px rgba(0,0,0,0.1) !important; }
.primary-text { color: #1e293b !important; }
.opacity-30 { opacity: 0.3; }
.w-100 { width: 100%; }

/* Profile specific styles */
.profile-hero-wrapper { width: 100%; position: relative; overflow: hidden; border-radius: 20px; }
.hero-gradient { position: absolute; bottom: 0; left: 0; width: 100%; height: 50%; background: linear-gradient(to top, rgba(0,0,0,0.6) 0%, transparent 100%); z-index: 1; pointer-events: none; }
.profile-sticky-card { position: sticky; top: 20px; z-index: 10; border-top: 1px solid rgba(255,255,255,0.8) !important; }
.avatar-container { border-radius: 50%; box-shadow: 0 0 0 4px rgba(25, 118, 210, 0.1); display: inline-block; }
.hover-stat { transition: all 0.2s ease; border-radius: 12px; padding: 12px 8px; }
.hover-stat:hover { background: rgba(0,0,0,0.03); transform: scale(1.02); }
.tracking-wide { letter-spacing: 0.05em; }
.line-height-relaxed { line-height: 1.6; }
.profile-cover .v-image__image { filter: brightness(0.9); }

.v-card__subtitle,
.v-card__text {
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 0.95rem !important;
  letter-spacing: 0.007143em;
}
.preview {
  margin: 10px;
}
.preview img {
  margin: 5px;
  max-width: 90%;
}
.v-chip.v-size--default {
  height: auto !important;
}
.v-chip .v-icon {
  font-size: 14px;
}
</style>
